<template>
  <page-outline :title="$t('profilesPage.profiles_title')">
    <template slot="pageContent">
		<b-container fluid>
			<template>
			  <b-row class="justify-content-center">
				<b-col cols="12" lg="11" xl="10" class="mt-3">
				  <div class="outline-content">
					  <form-accordion class="ml-3 mr-3" :title="$t('administration.company_details')"  :isTitleUpperCase="false">
						<b-row class="ml-5 mt-4 mb-4 mr-5 mr-5 form-group">
						  <b-col v-if="accountLogin" sm="5">
							<form-read-group-label-input
							  :inputLabel="$t('common.idtfr')" :inputValue="accountLogin ? accountLogin : '-'">
							</form-read-group-label-input>
						  </b-col>
						  <b-col v-if="accountEmailReference" sm="5">
							<form-read-group-label-input
							  :inputLabel="$t('common.eml')" :inputValue="accountEmailReference ? accountEmailReference : '-'">
							</form-read-group-label-input>
						  </b-col>
						</b-row>
						<b-row class="ml-5 mb-4 mr-5 mr-5 form-group">
						  <b-col v-if="accountName" sm="5">
							<form-read-group-label-input
							  :inputLabel="$t('common.nme')" :inputValue="accountName ? accountName : '-'"
							  >
							</form-read-group-label-input>
						  </b-col>
						  <b-col v-if="accountAddress" sm="5">
							<form-read-group-label-input
							  :inputLabel="$t('common.adrs')" :inputValue="accountAddress ? accountAddress : '-'"
							  >
							</form-read-group-label-input>
						  </b-col>
						</b-row>
						<b-row class="ml-5 mb-4 mr-5 mr-5 form-group">
						  <b-col v-if="accountCity" sm="5">
							<form-read-group-label-input
							  :inputLabel="$t('common.cty')" :inputValue="accountCity ? accountCity : '-'"
							  >
							</form-read-group-label-input>
						  </b-col>
						  <b-col v-if="accountZipCode" sm="5">
							<form-read-group-label-input
							  :inputLabel="$t('common.zp_code')" :inputValue="accountZipCode ? accountZipCode : '-'"
							  >
							</form-read-group-label-input>
						  </b-col>
						</b-row>
						<b-row class="ml-5 mb-4 mr-5 mr-5 form-group">
						  <b-col v-if="accountCountry" sm="5">
							<form-read-group-label-input
							  :inputLabel="$t('common.ctry')" :inputValue="accountCountry"
							  >
							</form-read-group-label-input>
						  </b-col>
						  <b-col v-if="accountType === '1' && accountLegalForm" sm="5">
							<form-read-group-label-input
							  :inputLabel="$t('common.lgl_frm')" :inputValue="accountLegalForm"
							  >
							</form-read-group-label-input>
						  </b-col>
						</b-row>
						<b-row class="ml-5 mb-4 mr-5 mr-5 form-group">
						  <b-col v-if="accountType === '1' && accountAmountOfCapital" sm="5">
							<form-read-group-label-input
							  :inputLabel="$t('common.shr_cptl')" :inputValue="accountAmountOfCapital"
							  >
							</form-read-group-label-input>
						  </b-col>
						  <b-col v-if="accountType === '1' && accountIdentifierTVA" sm="5">
							<form-read-group-label-input
							  :inputLabel="$t('common.tva_nbr')" :inputValue="accountIdentifierTVA"
							  >
							</form-read-group-label-input>
						  </b-col>
						</b-row>
					  </form-accordion>
					  <form-accordion class="ml-3 mr-3" :title="$t('administration.user_details')"  :isTitleUpperCase="false">
						<b-row class="ml-5 mt-4 mb-4 mr-5 mr-5 form-group">
						  <b-col sm="5">
							<form-read-group-label-input
							  :inputLabel="$t('administration.login')" :inputValue="userLogin ? userLogin : '-'">
							</form-read-group-label-input>
						  </b-col>
						  <b-col sm="5">
							<form-read-group-label-input
							  :inputLabel="$t('common.nme')" :inputValue="userName ? userName : '-'">
							</form-read-group-label-input>
						  </b-col>
						</b-row>
					  </form-accordion>
					  <b-row class="form-group justify-content-end mr-5">
						<!--
						<b-col lg="2" offset-lg="8" v-if="hasRight('profil_editer')">
						  <b-button variant="primary" size="lg"
							@click="editProfile">
							<i class="fa-light fa-pen-to-square" size="17px"></i>
							<span>{{ $t('profilesPage.edit_prfl') }}</span>
						  </b-button>
						</b-col>
						-->
						<div sm="2" v-if="hasRight('change_password')">
						  <b-button
							variant="primary" size="lg"
							@click="changePassword">
							<i class="fa-light fa-gear" size="17px"></i>
							<span v-if="displayChangerPassword">{{ $t('common.chg_pwd') }}</span>
							<span v-else>{{ $t('common.def_pwd') }}</span>
						  </b-button>
						</div>
					  </b-row>
					</div>
            </b-col>
          </b-row>
        </template>
      </b-container>
    </template>
  </page-outline>
</template>

<script>
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
// import {errorMessageAlert} from '@/helpers/alert'
// import qrcode from 'qrcode'

import {loadPage} from '@/helpers/routing'

export default {
  components: {
    'bottom-toolbar': bottomToolbar,
    'form-accordion': FormAccordion,
    'form-read-group-label-input': formReadGroupLabelInput,
    'page-outline': PageOutline
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      accountType: '',
      accountName: '',
      accountLogin: '',
      accountAddress: '',
      accountCity: '',
      accountZipCode: '',
      accountCountry: '',
      accountEmailReference: '',
      accountLegalForm: '',
      accountAmountOfCapital: '',
      accountIdentifierTVA: '',
      displayChangerPassword: true,
      userAccountInfo: {}
    }
  },
  created () {
    this.profilesPage_ProfileInformation = this.$i18n.t('leftPanelTitle.prof_info')
    this.$f7.params.swipePanel = this.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    this.$f7.params.panelsCloseByOutside = this.$engine.services.directPayments.filter.smartphoneStorage
    this.accountType = this.$engine.user.get().type
    this.accountName = this.$engine.user.get().name
    this.accountLogin = this.$engine.user.get().identifier
    this.accountAddress = this.$engine.user.get().address
    this.accountCity = this.$engine.user.get().city
    this.accountZipCode = this.$engine.user.get().zip_code
    this.accountCountry = this.$engine.user.get().country
    this.accountEmailReference = this.$engine.user.get().email_reference
    this.accountLegalForm = this.$engine.user.get().legalForm
    this.accountAmountOfCapital = this.$engine.user.get().amountOfCapital
    this.accountIdentifierTVA = this.$engine.user.get().identifierTVA
    this.getUserAccountInfo()
  },
  mounted () {
    // var canvas = document.getElementById('qrcodeCanvas')
    //
    // let parameters = {
    //   idAccount: 92
    // }
    // console.log(JSON.stringify(parameters))
    // qrcode.toCanvas(canvas, JSON.stringify(parameters), function (error) {
    //   if (error) console.error(error)
    //   console.log('success!')
    // })
    if (this.$engine.user.connectBy === 'vue-google-oauth2') {
      this.displayChangerPassword = false
    } else {
      this.displayChangerPassword = true
    }
  },
  methods: {
    changePassword () {
      loadPage(this, {
        url: '/profile/changePassword/'
      })
    },
    editProfile () {
      loadPage(this, {
        url: '/profile/edit/'
      })
    },
    getUserAccountInfo () {
      let info = this.$engine.accounts.get()
      let userAccounts
      let userAccountId

      userAccounts = info[0].userAccts
      userAccountId = info[0].userAccountId
      userAccounts = userAccounts.filter((account) => account.id === userAccountId)
      this.updateUserAccountInfo(userAccounts)
    },
    hasRight (right) {
      return this.$engine.rights.rightIs(right, '1')
    },
    updateUserAccountInfo (userAccount) {
      this.userAccountInfo = userAccount
      this.userLogin = this.userAccountInfo[0].login
      this.userName = this.userAccountInfo[0].name
      this.userProfile = this.userAccountInfo[0].profile
    }
  }
}
</script>


<style scoped>
/*
@media (max-width:  768px) {
  .col-md-3 {
    margin-top: -20px;
  }
}
*/
</style>
